import { useEffect, useState } from 'react'
import {
	BrowserRouter as Router,
	Navigate,
	Route,
	Routes,
} from 'react-router-dom'

//Redux
import { Provider } from 'react-redux'
import { store } from './redux/store'

//Components & Containers
import Header from './components/Header'
import NotFound from './containers/NotFound'
import ScreenSize from './components/ScreenSize'

//Styles and Animations
import GlobalStyles from './styles/GlobalStyles'
import GlobalFonts from './fonts/fonts'
import { useTransition, animated } from 'react-spring'
import Switch from './containers/Switch'
import { Loader } from './styles/Loader'

const App = () => {
	const [isLoaded, setIsLoaded] = useState(false)

	const transition = useTransition(isLoaded, {
		from: { x: 0, y: 800, opacity: 0, delay: 800 },
		enter: { x: 0, y: 0, opacity: 1, delay: 800 },
		leave: { x: 0, y: 800, opacity: 0, delay: 800 },
	})

	useEffect(() => {
		setIsLoaded(true)
	}, [])

	return (
		<Provider store={store}>
			<ScreenSize>
				<Router>
					<GlobalStyles />
					<GlobalFonts />
					{transition((style, item) =>
						item ? (
							<animated.div style={style}>
								<Header />
								<Routes>
									<Route
										path="/"
										element={<Navigate replace to="/GoldenWeek" />}
									/>
									<Route path="*" element={<NotFound />} />
									<Route path="/GoldenWeek" element={<Switch />} />
								</Routes>
							</animated.div>
						) : (
							<Loader />
						)
					)}
				</Router>
			</ScreenSize>
		</Provider>
	)
}

export default App
